import React, { useState } from 'react'
import _ from 'lodash'
import '../../styles/scss/elements/accomodation-detail.scss'

import Slider from 'react-slick'
import '../../styles/scss/elements/slick.scss'
import '../../styles/scss/elements/slick-theme.scss'

import PrevSilde from '../../assets/icons/previous-slide.svg'
import NextSlide from '../../assets/icons/next-slide.svg'
import { htmlDecode, removeEscapeHTML } from '../../utilities/content/formatContent'
import { onEnter } from '../../utilities/accessibility/onEnter'

const OtherInformation = ({ name, content }) => {
  return (
    <div className="other-information__wrapper">
      <div className="other-information__header">{name}</div>
      <div className="other-information__description">
        <div dangerouslySetInnerHTML={{ __html: htmlDecode(content) }} />
      </div>
    </div>
  )
}

const AccommodationDetail = ({ accommodation }) => {
  const [slider, setSlider] = useState()

  const renderArrows = () => {
    return (
      <div className="slider-arrow">
        <div
          className="arrow-btn prev"
          onClick={() => slider.slickPrev()}
          onKeyDown={event => onEnter(event, slider.slickPrev)}
        >
          <img src={PrevSilde} alt="previous-slide" />
        </div>
        <div
          className="arrow-btn next"
          onClick={() => slider.slickNext()}
          onKeyDown={event => onEnter(event, slider.slickNext)}
        >
          <img src={NextSlide} alt="next-slide" />
        </div>
      </div>
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  const description = Array.isArray(_.get(accommodation, 'description'))
    ? _.get(accommodation, 'description[0]')
    : _.get(accommodation, 'description');
  const images = _.has(accommodation, 'viewExtensions.images')
    ? _.get(accommodation, 'viewExtensions.images')
    : _.has(accommodation, 'images')
    ? _.get(accommodation, 'images')
    : [_.get(accommodation, 'defaultImage')]

  return (
    <div className="accommodation-detail">
      <section className="accommodation-detail__title">
        <h4 aria-label={accommodation && accommodation.name}>
          About <span dangerouslySetInnerHTML={{ __html: htmlDecode(accommodation.name) }} />
        </h4>
      </section>
      <section className="accommodation-detail__description">
        <p>{description && removeEscapeHTML(description)}</p>
      </section>
      {!_.isEmpty(images) && (
        <section className="accommodation-detail__slider">
          <Slider {...settings} className="accomodation-slider" ref={c => setSlider(c)}>
            {_.map(images, (image, index) => (
              <div key={`${index}`}>
                <img alt={_.get(image, 'description')} src={_.get(image, 'path')} />
              </div>
            ))}
          </Slider>
          {images.length > 1 && renderArrows()}
        </section>
      )}
      <section className="accommodation-detail__amenites-information">
        {accommodation && accommodation.amenities && (
          <div className="amenites">
            <h2 className="accommodation-detail__amenites-information__title" aria-label="Amenites">
              Amenities
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: htmlDecode(accommodation.amenities[0])
              }}
            />
          </div>
        )}
        <div className="other-information">
          <h2
            className="accommodation-detail__amenites-information__title"
            aria-label="Other Information"
          >
            Other Information
          </h2>
          {accommodation && accommodation.address && accommodation.address !== '' && (
            <OtherInformation name={'Address'} content={accommodation.address} />
          )}
          {accommodation && accommodation.general && accommodation.general !== '' && (
            <OtherInformation name={'General'} content={accommodation.general} />
          )}
          {accommodation && accommodation.valueAdd && accommodation.valueAdd !== '' && (
            <OtherInformation name={'Value Added'} content={accommodation.valueAdd} />
          )}
          {accommodation && accommodation.dailyParking && accommodation.dailyParking !== '' && (
            <OtherInformation name={'Daily Parking'} content={accommodation.dailyParking} />
          )}
        </div>
      </section>
    </div>
  )
}

export default AccommodationDetail
